import { Address } from '@typeRoots/common/address';

export const formatAddressToString = (address: Address): string => {
  const { street, city, state, zipCode } = address;

  // Format as "Street, City, State ZIP"
  if (street.length > 0) {
    return `${street}, ${city}, ${state} ${zipCode}`;
  } else {
    return '';
  }
};

export const mapFetchApi = async (token: string, url: string) => {
  const options = token ? { headers: { Authorization: `Bearer ${token}` } } : undefined;
  const response = await fetch(url, options);
  return response;
};

/*export const getAddressWithCounty = async (address: Address, token: string) => {
  try {
    // Create a formatted address string
    const formattedAddress = [
      address.street,
      address.city,
      address.state,
      address.zipCode,
      address.county,
    ]
      .filter(Boolean) // Remove empty or null values
      .join(', '); // Join with commas

    /*const response = await fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(formattedAddress)}&key=${apiKey}`,
    );//comment out the above line
    const response = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}/auth/address?address=${encodeURIComponent(formattedAddress)}`
    );

    const data = await response.json();
    if (data.status === 'OK' && data.results.length > 0) {
      const { lat, lng } = data.results[0].geometry.location;
      try {
        /*const response = await fetch(
          `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${apiKey}`,
        );
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/auth/latlng?lat=${lat}&lng=${lng}`,
        );
        const data = await response.json();
        if (data.results.length > 0) {
          console.log(
            'Formatted Address: ',
            data.results[0]?.address_components as AddressComponent[],
          );
          let newAddress = formatAddress(
            data.results[0]?.address_components as AddressComponent[],
          ) as Address;
          console.log('New Address: ', newAddress);
          return (newAddress = {
            ...address,
            latitude: lat,
            longitude: lng,
          });
        } else {
          console.error('No results found');
          return address;
        }
      } catch (error) {
        console.error('Error fetching address:', error);
        return address;
      }
    } else {
      console.error('Error fetching geocode:', data.error_message || data.status);
      return address;
    }
  } catch (error) {
    console.error('Failed to fetch latitude and longitude:', error);
    return address;
  }
};


const formatAddress = (components: AddressComponent[]) => {
  let streetNumber = '';
  let route = '';
  let locality = '';
  let administrativeArea = '';
  let postalCode = '';
  let county = '';

  components.forEach((component) => {
    //string address = line1, either line1 or the formatted address from detailed component
    //city = locality = component.types.includes('locality')
    //state =        administrativeArea = component.short_name;administrative_area_level_1
    //zipcode =         postalCode = component.long_name;postal_code
    //county = "administrative_area_level_2"
    if (component.types.includes('street_number')) {
      streetNumber = component.long_name;
    } else if (component.types.includes('route')) {
      route = component.long_name;
    } else if (component.types.includes('locality')) {
      locality = component.long_name;
    } else if (component.types.includes('administrative_area_level_1')) {
      administrativeArea = component.short_name;
    } else if (component.types.includes('administrative_area_level_2')) {
      county = component.short_name;
    } else if (component.types.includes('postal_code')) {
      postalCode = component.long_name;
    }
  });

  const line1 = `${streetNumber} ${route}`.trim(); // First line: street address

  const address = {
    street: line1,
    city: locality,
    state: administrativeArea,
    zipCode: postalCode,
    county: county,
  } as Address;
  return address;
};*/
